import React from 'react';

const PremiumIcon = ({
  width = 28,
  height = 28,
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M4.10455 12.0234C3.65181 10.7703 3.42545 10.1438 3.52198 9.74234C3.62755 9.30323 3.93983 8.9609 4.33898 8.84671C4.70392 8.74229 5.27162 8.9946 6.40702 9.49923C7.41128 9.94559 7.91342 10.1688 8.3852 10.1563C8.90466 10.1427 9.40436 9.93437 9.80186 9.56578C10.1629 9.23102 10.405 8.69757 10.8893 7.63067L11.9567 5.27938C12.8483 3.31529 13.294 2.33325 14 2.33325C14.7059 2.33325 15.1517 3.31529 16.0433 5.27938L17.1107 7.63067C17.595 8.69757 17.8372 9.23102 18.1981 9.56578C18.5956 9.93437 19.0953 10.1427 19.6148 10.1563C20.0866 10.1688 20.5887 9.94559 21.593 9.49923C22.7284 8.9946 23.2961 8.74229 23.661 8.84671C24.0602 8.9609 24.3725 9.30323 24.4781 9.74234C24.5745 10.1438 24.3482 10.7703 23.8954 12.0232L21.9494 17.4092C21.1169 19.7131 20.7007 20.8651 19.8296 21.5158C18.9586 22.1666 17.833 22.1666 15.5818 22.1666H12.4182C10.167 22.1666 9.0414 22.1666 8.17034 21.5158C7.29929 20.8651 6.88306 19.7131 6.05059 17.4092L4.10455 12.0234Z"
        fill="url(#paint0_linear_23565_143369)"
      />
      <path
        d="M14 16.3333H14.0097"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16602 25.6667H19.8327"
        stroke="url(#paint1_linear_23565_143369)"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23565_143369"
          x1="-3.5"
          y1="8.94337"
          x2="25.2"
          y2="8.94337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D998" />
          <stop offset="1" stopColor="#A175FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_23565_143369"
          x1="4.27713"
          y1="26"
          x2="20.2216"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D998" />
          <stop offset="1" stopColor="#A175FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PremiumIcon;
